import { parentesco } from '@utils';
import {
  casoUniaoEstavel,
  certidaoGenitor,
  childs,
  commons,
  convivente,
  death,
  others,
  parents,
  specialChild,
  spouses,
  termoTutelaJudicial,
} from '../constants';
import { initialValuesGenerator } from '../initialValueGenerator';
import { dynamicRule } from '../rules';

const { constants } = parentesco;

export const RCMADocs = () => {
  const rules = {
    anexoCertidaoDeObito: dynamicRule('required'),
    anexoCertidaoCasamentoOuNascimento: dynamicRule('pais'),
    anexoRG: dynamicRule('required'),
    anexoCPF: dynamicRule('required'),
    anexoCertidaoCasamento: dynamicRule('casamento'),
    anexoCertidaoNascimento: dynamicRule('nascimento'),
    anexoLaudoMedico: dynamicRule('laudoMedico'),

    anexoConvivente: dynamicRule('convivente'),
    anexoCasoUniaoEstavel: dynamicRule(),

    anexoCertidaoCasamentoGenitor: dynamicRule('enteado'),
    anexoOutros: dynamicRule(),
    anexoTermoTutelaJudicial: dynamicRule('menorTutelaAdd'),
  };
  const docs = {
    commons: [...commons],
    others: [...others],
    [constants.PAI]: [...death, ...parents],
    [constants.MAE]: [...death, ...parents],
    [constants.CONJUGE]: [...death, ...spouses],
    [constants.EX_CONJUGE]: [...death, ...spouses],
    [constants.FILHO]: [...death, ...childs],
    [constants.MENOR_TUTELA]: [...childs, ...termoTutelaJudicial, ...death],
    [constants.FILHO_ESPECIAL]: [...death, ...childs, ...specialChild],
    [constants.CONVIVENTE]: [...death, ...convivente, ...casoUniaoEstavel],
    [constants.ENTEADO]: [...death, ...childs, ...certidaoGenitor],
  };

  const initialValues = initialValuesGenerator(docs);

  return {
    initialValues,
    rules,
    docs,
  };
};
